<template>
  <div>
    <div class="wrap" v-loading.fullscreen.lock="loading">
      <div class="sectionBox">
        <div class="rSec">
          <div class="lInner">
            <div class="banner">
              <template v-if="banner_main">
                <el-carousel height="287px">
                  <el-carousel-item v-for="item in banner_main" :key="item.id" v-show="Number(item.show)">
                    <a :href="item.url" target="_blank"><img width="710" height="287" :src="item.path"></a>
                  </el-carousel-item>
                </el-carousel>
              </template>
            </div>
          </div>
        </div>
        <div class="login">
          <div v-if="!userInfo">
            <login :type="1" @showregist="showRegist"></login>
          </div>
          <div class="logined" v-else>
            <p class="wel">
              欢迎回来！{{userInfo.username}}
              <a @click="toNewPage('/message')" target="_blank">(<b style="color:red;">{{userInfo.unReadCount}}</b>条新消息)</a>
            </p>
            <ul class="nav">
              <li @click.stop.prevent="xgFormVisible = true">
                <img src="/static/img/ic_3.png" class="img01" alt="">
                <span >修改密码</span>
                </li>
              <li @click.stop.prevent="showUpload">
                <img src="/static/img/ic_4.png" class="img01" alt="">
                <span >账号认证</span>
              </li>
              <li @click.stop.prevent="showBuyRecord">
                <img src="/static/img/ic_5.png" class="img01" alt="">
                <span >购买记录</span>
              </li>
              <li @click.stop.prevent="showSellRecord">
                <img src="/static/img/ic_5.png" class="img01" alt="">
                <span >出售记录</span>
              </li>
              <li @click="ifLogout">
                <img src="/static/img/ic_3.png" class="img01" alt="">
                <span >注销登录</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="sec" v-loading="n_loading">
        <latestnews></latestnews>
        <div class="new-sell">
          <top :title="'最新出售账号'">
            <a @click="toNewPage('/sold-acc')" target="_blank" class="more">查看更多 &gt;</a>
          </top>
          <div class="new-s-t">
            <p class="head">
              <span>会员账号</span>
              <span v-if="config_info.sale_extend!=='1'">等级</span>
              <span v-if="config_info.sale_extend!=='1'" v-show="config_info.finance_salary_status === '1'">等级礼金</span>
              <span v-if="config_info.sale_extend!=='1'" v-show="config_info.week_salary_status === '1'">周俸禄</span>
              <span v-if="config_info.sale_extend!=='1'" v-show="config_info.month_salary_status === '1'">月俸禄</span>
              <span v-if="config_info.sale_extend==='1'">VIP等级</span>
              <span v-if="config_info.sale_extend==='1'">电子等级</span>
              <span v-if="config_info.sale_extend==='1'">真人等级</span>
              <span>标价</span>
              <span>操作</span>
            </p>
            <section class="con" ref="area">
              <ul class="area" ref="con" v-if="new_sold_list.length">
                <li v-for="item in new_sold_list" :key="item.id">
                  <span>{{item.account}}</span>
                  <span v-if="config_info.sale_extend!=='1'">{{item.e_level}}级</span>
                  <span v-if="config_info.sale_extend!=='1'" v-show="config_info.finance_salary_status === '1'">{{item.e_up_reward}}</span>
                  <span v-if="config_info.sale_extend!=='1'" v-show="config_info.week_salary_status === '1'">{{item.e_week_reward}}</span>
                  <span v-if="config_info.sale_extend!=='1'" v-show="config_info.month_salary_status === '1'">{{item.e_month_reward}}</span>
                  <span v-if="config_info.sale_extend==='1'">{{item.vip_level}}</span>
                  <span v-if="config_info.sale_extend==='1'">{{item.e_level}}</span>
                  <span v-if="config_info.sale_extend==='1'">{{item.r_level}}</span>
                  <span>￥{{item.sale_price}}元</span>
                  <span class="suc">交易成功</span>
                </li>
              </ul>
            </section>
          </div>
        </div>
        <div class="sell-home" v-loading="s_loading">
          <pricelist :title="'出售大厅'" :data="goodList" :page="goodsPage" @showlogin="showLogin"
          @changepage="changeGoodsPage" @changepagesize="changeGoodsPageSize"></pricelist>
        </div>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="xgFormVisible" custom-class="dialog-t" width="677px">
      <div class="form">
        <div class="input_text">
          <span class="label">旧密码</span>
          <input type="password" class="text" v-model="xg_form.old_pwd">
        </div>
        <div class="input_text">
          <span class="label">新密码</span>
          <input type="password" class="text" v-model="xg_form.new_pwd">
        </div>
        <div class="input_text">
          <span class="label">确认新密码</span>
          <input type="password" class="text" v-model="xg_form.rep_pwd">
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatePwd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="我购买的账号" :visible.sync="gmTableVisible" custom-class="dialog-t" width="900px">
      <recordlist :title="'我购买的账号'" :page="buysPage" :type="1" :list="buyRecord" @changepage="changeBuysPage"></recordlist>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="gmTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="我出售的账号" :visible.sync="csTableVisible" custom-class="dialog-t" width="880px">
      <recordlist :title="'我出售的账号'" :page="sellsPage" :type="2" :list="sellRecord" @changepage="changeSellsPage"></recordlist>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="csTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <upload-dialog ref="upload"></upload-dialog>

  </div>
</template>


<script>
  import uploadDialog from '@/components/common/uploadImg/uploadDialog'
  import recordlist from '@/components/common/recordlist/recordlist'
  import login from '@/components/login/login'
  import pricelist from '@/components/common/pricelist/priceList'
  import latestnews from '@/components/common/latestnews/latestNews'
  import top from '@/components/common/top/top'
  import { formatDate } from '@/common/js/common'
  import { saleResource, userResource, buyResource } from '@/resource/resource'
  import { mapState, mapMutations } from 'vuex'
  import { getCookie } from '@/common/js/cookies'
  // import $ from 'jquery'

  const ERR_OK = 0

  export default {
    name: 'index',
    data () {
      return {
        xgFormVisible: false,
        xg_form: {
          old_pwd: '',
          new_pwd: '',
          rep_pwd: ''
        },
        gmTableVisible: false,
        csTableVisible: false,
        new_sold_list: [],
        buyRecord: [],
        buysPage: {
          'page_current': 1,
          'page_size': 5,
          'total_count': 0,
          'total_page': 1
        },
        sellRecord: [],
        sellsPage: {
          'page_current': 1,
          'page_size': 5,
          'total_count': 0,
          'total_page': 1
        },
        goodList: [],
        goodsPage: {
          'page_current': 1,
          'page_size': 20,
          'total_count': 0,
          'total_page': 1
        },
        goods_page_size: 10,
        s_loading: false, // goodlist
        n_loading: false, // n-s-t
        // //
        loading: false, // 登录加载
        notice: true, // 切换公告
        homeNew: null, // 开奖公告对象
        winList: [], // 中奖信息数组
        article: null, // 咨询对象
        user_window: null,
        lottery_window: null,
        topList: [],
        all_bonus: 0,
        refresh: false, // 调用余额接口前显示---
        showLoginBox: false, // 是否显示登录框
        show_lot: null, // 快速投注要显示的彩种
        newsMulti: null, // 六合彩和彩票对象
        isshow: false,
        dialog: {} // 图片弹窗
      }
    },
    // props: ['loading'],
    computed: {
      ...mapState(['userInfo', 'logined', 'config_info', 'noticeList']),
      banner_main() {
        let ret = []
        if (this.config_info.banner_main) {
          let obj = JSON.parse(this.config_info.banner_main)
          ret = Object.keys(obj).map((i) => {
            return obj[i]
          })
        }
        return ret
      },
      finance_salary_status() {
        let ret = ''
        if (this.config_info.finance_salary_status) {
          ret = this.config_info.finance_salary_status.toString()
        }
        return ret
      }
    },
    created () {
      this.goods_page_size = this.config_info.service_main_sell_limit
      this.getNewSoldList()
      this.getGoodList({type: 1, count: this.goods_page_size, on_front: 1})
      this.onLogout()
      if (this.userInfo) {
        this.getUserInfo()
      }
    },
    mounted () {
    },
    beforeRouteLeave (to, from, next) {
      next()
    },
    destroyed () {
      clearInterval(this.eventLogout)
    },
    methods: {
      handleLoading(data) {
        this.loading = data
      },
      showUpload() {
        if (Number(this.userInfo.auth_status) === 0) {
          this.$refs.upload.showDialog(true)
        }
        if (Number(this.userInfo.auth_status) === 1) {
          this.$alert('已认证', '温馨提示', {
            confirmButtonText: '确定'
          })
        }
        if (Number(this.userInfo.auth_status) === 2) {
          this.$alert('申请中', '温馨提示', {
            confirmButtonText: '确定'
          })
        }
      },
      showRegist() {
        this.$emit('showregist', 'index')
      },
      showLogin() {
        this.$emit('showlogin', true)
      },
      getGoodList (params) {
        this.s_loading = true
        saleResource.list(params).then(res => {
          res = res.body
          this.s_loading = false
          if (res.errcode === ERR_OK) {
            this.goodList = res.data
            this.goodsPage = res.page
          }
        })
      },
      changeGoodsPage(val) {
        this.getGoodList({type: 1, count: this.goods_page_size, page: val - 1, on_front: 1})
      },
      changeGoodsPageSize(size) {
        this.goods_page_size = size
        this.getGoodList({type: 1, count: size, on_front: 1})
      },
      showBuyRecord() {
        if (!this.buyRecord.length) {
          this.getBuyRecord(1, {count: 5})
        } else {
          this.gmTableVisible = true
        }
      },
      getBuyRecord(type, params) {
        this.loading = true
        buyResource.list(params).then(res => {
          res = res.body
          this.loading = false
          if (res.errcode === ERR_OK) {
            this.buyRecord = res.data
            this.buysPage = res.page
            if (type === 1) {
              this.gmTableVisible = true
            }
          }
        })
      },
      changeBuysPage(val) {
        this.getBuyRecord(0, {count: 5, page: val - 1})
      },
      showSellRecord() {
        if (!this.sellRecord.length) {
          this.getSellRecord(1, {count: 5})
        } else {
          this.csTableVisible = true
        }
      },
      getSellRecord(type, params) {
        this.loading = true
        saleResource.userlist(params).then(res => {
          res = res.body
          this.loading = false
          if (res.errcode === ERR_OK) {
            this.sellRecord = res.data
            this.sellsPage = res.page
            if (type === 1) {
              this.csTableVisible = true
            }
          }
        })
      },
      changeSellsPage(val) {
        this.getSellRecord(0, {count: 5, page: val - 1})
      },
      getNewSoldList () {
        saleResource.list({type: 2}).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.new_sold_list = res.data
            // 滚动信息
            this.$nextTick(() => {
              let area = this.$refs.area
              let con = this.$refs.con || {}
              while (area.clientHeight > con.clientHeight) {
                con.innerHTML += '<li>&nbsp;</li>'
              }
              area.innerHTML += area.innerHTML
              area.scrollTop = 0
              function scrollMove() {
                area.scrollTop++
                setInterval(() => { scrollUp() }, 50)
              }
              function scrollUp() {
                area.scrollTop++
                if (area.scrollTop >= area.scrollHeight / 2) {    // 判断滚动高度,当滚动高度大于area本身的高度时，使其回到原点重新滚动
                  area.scrollTop = 0
                }
              }
              scrollMove()
            })
          }
        })
      },
      toNewPage(url) {
        window.open(window.location.origin + url)
      },
      updatePwd () {
        if (!this.xg_form.old_pwd) {
          this.$alert('旧密码不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
        if (!this.xg_form.new_pwd) {
          this.$alert('新密码不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
        if (!this.xg_form.rep_pwd) {
          this.$alert('确认新密码不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
        if (this.xg_form.new_pwd !== this.xg_form.rep_pwd) {
          this.$alert('新密码与确认新密码不一致', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
        this.loading = true
        userResource.resetpwd(this.xg_form).then(response => {
          response = response.body
          this.loading = false
          if (response.errcode === ERR_OK) {
            this.xg_form.new_pwd = ''
            this.xg_form.old_pwd = ''
            this.xg_form.rep_pwd = ''
            this.$alert(response.data, '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.xgFormVisible = false
                this.OUT_LOGIN()
                this.captcha = ''
                this.showCaptcha = false
              }
            })
          }
        })
      },
      // 监听退出事件
      onLogout () {
        this.eventLogout = setInterval(() => {
          if (!getCookie('isLogined')) {
            this.OUT_LOGIN()
            clearInterval(this.eventLogout)
          }
        }, 2000)
      },
      ifLogout () {
        this.$confirm('确定要注销登录吗？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          callback: action => {
            if (action === 'confirm') {
              this.logout()
            }
          }
        })
      },
      // 退出登录
      logout () {
        this.loading = true
        userResource.logout().then(response => {
          response = response.body
          this.loading = false
          if (response.errcode === ERR_OK) {
            this.OUT_LOGIN()
            this.captcha = ''
            this.showCaptcha = false
            // this.flag = false
          }
        })
      },
      getUserInfo() {
        userResource.info().then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.RECORD_USERINFO(res.data)
          }
        })
      },
      // 更新vuex状态信息
      ...mapMutations([
        'RECORD_USERINFO',
        'OUT_LOGIN'
      ])
    },
    filters: {
      formatDate(time) {
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      },
      ellipsis(str, num) {
        if (str.length > num) {
          str = str.substring(0, num)
          str += '...'
        }
        return str
      }
    },
    components: {
      latestnews,
      top,
      pricelist,
      login,
      recordlist,
      uploadDialog
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .wrap
    width 1000px
    margin 0 auto
    position relative
    .sectionBox
      margin-top 10px
      display flex
      justify-content space-between
      .rSec
        width 710px
        .lInner
          width 710px
          .banner
            margin-bottom 10px
            position relative
            width 710px
            height 287px
            & > .el-carousel
              overflow-y hidden
          .newsBox
            margin-bottom 10px
            clear both
            position relative
            cursor pointer
            dt
              padding 0 0 10px 23px
              font-size 14px
              float left
              color #ff551a
              border-bottom 1px solid #ff551a
            dd
              width 390px
              font-size 13px
              padding 0 30px 10px 100px
              border-bottom 1px solid #E1E1E1
            .bd
              min-height 14px
              & span
                margin-right 50px
          .box
            height 172px
            margin-bottom 10px
            border 1px solid #E4E4E4
            background-color #FFF
            .topBox
              background-color #eee
              margin-bottom 10px
              li
                width 129px
                float left
                a
                  color #666
                  font-size 12px
                  line-height 34px
                  display block
                  text-align center
                  background-color #EEE
                  border 1px solid #E4E4E4
                  border-right none
                &.on
                  a
                    color #ff551a
                    background-color #fff
                    border-bottom 1px solid #fff
            .tabPanel
              .info
                margin 0 10px 10px 10px
              p
                float left
                span
                  margin-right 20px
                i
                  font-style normal
                  color #ff5a00
              .linkUl
                float right
                li
                  color #b0b0b0
                  argin-left 8px
                  display inline-block
                  a
                    margin 0 10px 0 0
                    color #b0b0b0
                    font-size 12px
              dl
                margin 0 0 15px 9px
              dd
                padding 8px 0 0 0
                li
                  margin-right 9px
                  width 42px
                  height 42px
                  float left
                  text-align center
                  color #fff
                  font-size 24px
                  font-family Arial
                  font-weight bold
                  line-height 45px
                  border-radius 50%
                  background-color #FF5A00
                  &:last-child
                    margin 0
              .btmBox
                padding 5px
                border-top 1px solid #E1E1E1
              .link01
                margin 5px 100px 0 0
                float left
                a
                  color #999
                  font-size 14px
                  img
                    margin -2px 8px 0 0
                    display inline-block
                    vertical-align middle
              .jsBox
                margin 4px 20px 0 0
                float left
                width 200px
                a
                  display block
                  float left
                  vertical-align middle
                  img
                    display block
                    vertical-align top
                input
                  margin 0
                  padding 0
                  width 30px
                  height 20px
                  float left
                  color #6f6f6f
                  font-family Arial
                  font-size 14px
                  font-weight bold
                  line-height 20px
                  text-align center
                  border none
                .txtBox
                  padding 3px 0 0 5px
                  display block
                  float left
                  color #6f6f6f
                  font-size 14px
                  span
                    color #ff5a00
              .link02
                float right
                a
                  width 90px
                  display block
                  color #fff
                  font-size 14px
                  line-height 28px
                  text-align center
                  border-radius 2px
                  background-color #FF5A00
          .infoBox
            height 341px
            margin-bottom 10px
            .title
              padding 9px 10px 8px
              overflow hidden
              zoom 1
              img
                display inline-block
                margin-right 7px
                vertical-align middle
              span
                display inline-block
                color #333
                font-size 14px
                font-weight bold
              a
                margin-top 2px
                display block
                float right
                color #999
                font-size 12px
            .border
              border 1px solid #E4E4E4
              background-color #FFF
              padding 10px 10px 0
              height 295px
            dl
              margin-bottom 15px
            dt
              float left
            dd
              padding 0 0 0 110px
              font-size 18px
              line-height 28px
              a
                color #ff5a00
                text-decoration underline
            ul
              position relative
            li
              padding 0 0 18px 5px
              width 244px
              float left
              color #bbb
              font-size 14px
              a
                margin-left 8px
                color #666
          .bannerImg
            cursor pointer
      .login
        width 278px
        height 285px
        border solid 1px #dcdcdc
        .logined
          padding 15px 22px
          background #fff
          .wel
            color #434343
            font-size 15px
            margin-bottom 10px
          .nav
            & > li
              margin-bottom 6px
              border solid 1px #dcdcdc
              background #f9f9f9
              height 38px
              padding-left 60px
              line-height 38px
              color #707070
              font-size 15px
              display flex
              align-items center
              cursor pointer
              & > img
                margin-right 15px
    .sec
      .new-sell
        .new-s-t
          border solid 1px #dcdcdc
          .head
            display flex
            line-height 40px
            background #efefef
            color #626262
            text-align center
            font-size 14px
            & > span
              flex 1
          .con
            height 120px
            overflow hidden
            width 100%
            font-size 12px
            line-height 16px
            position relative
            user-select none
            .area
              & > li
                border-bottom solid 1px #dcdcdc
                display flex
                line-height 40px
                & > span
                  flex 1
                  color #626262
                  font-size 13px
                  text-align center
                .suc
                  color #e60012
  .dialog-img
    text-align center
.yongligao .more
  border: 1px solid $primary !important
  color: $primary !important

</style>



// WEBPACK FOOTER //
// index.vue?de60f6a0